'use client'

import { ContentWrapper } from '@/General/ContentWrapper'
import { MasterclassButton } from '@/MasterclassButton'
import { useSubscriptionEligibility } from '@/useSubscriptionEligibility'
import { useStorefrontDisplayCurrency } from '@/useStorefrontDisplayCurrency'

export const SubscribeButtonSection = () => {
  const {
    isSubscriber,
    hasHadSubscriptionBefore,
    isEligibleForTrial,
    isLoading,
  } = useSubscriptionEligibility()
  const { currencySymbol } = useStorefrontDisplayCurrency()

  // Hide top join banner for existing subscribers.
  if (isSubscriber || isLoading) {
    return null
  }

  // Don't show pricing text if subscriber (they'll see "Go to your account")
  const showPricingText = true

  return (
    <section className="bg-vi-red py-8 md:py-12">
      <ContentWrapper>
        <div className="max-w-2xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-white">
            Join Vanishing Inc. Masterclass
          </h2>
          <p className="text-lg text-white/90">
            Access 400+ hours of exclusive magic lectures, monthly Q&As, and
            world-class instruction
          </p>
          <MasterclassButton
            className="w-full md:w-auto px-8 py-4 bg-white text-vi-red rounded-md font-semibold hover:bg-gray-100 transition-colors text-lg"
            variant="large"
          />
          {showPricingText && (
            <p className="text-white/90 text-sm">
              {hasHadSubscriptionBefore && !isEligibleForTrial
                ? `Monthly subscription is ${currencySymbol}50.00 and automatically renews each month until cancelled.`
                : `After your trial, the monthly subscription is ${currencySymbol}50.00 and automatically renews each month until cancelled.`}
            </p>
          )}
        </div>
      </ContentWrapper>
    </section>
  )
}
